import { useState, useEffect } from "react";
import * as ReactBootStrap from "react-bootstrap";
import FormData from "form-data";
import axios from "axios";

function SignCrop() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    account_no: "",
    holdername: "",
    ifsc_code: "",
  });
  const [img, setImg] = useState();
  const [previewImg, setPreviewImg] = useState();
  const [loading, setLoading] = useState(true);
  const [documentType, setDocumentType] = useState("backgroundRemoval");

  useEffect(() => {}, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      setImg("b " + base64String);
      setPreviewImg(reader.result);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
      Document_type: "",
      account_no: "",
      holdername: "",
      ifsc_code: "",
      status: "",
      document_type: "",
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var url = "";
    var apiKey = "ZqU6d8HxO37RmaHJum8tX1LYZ2k44uz9HZMHKdoi"; // Replace with your default API key
    var authorizationToken = ""; // Replace with your default authorization token

    if (documentType === "backgroundRemoval") {
      url =
        "https://pzv3rtdoy6.execute-api.ap-south-1.amazonaws.com/default/ainxt_signature-background-remover?type=BackgroundRemove";
    } else if (documentType === "croppedImage") {
      url =
        "https://z0c3azcfr7.execute-api.ap-south-1.amazonaws.com/default/SignatureScoreAPIPDF";
      apiKey = "37zugQDEKXaQ8vNZyUvdL3r6FDNqOcms9ogvT7ae"; // Replace with the API key for the Cropped Image API
      authorizationToken = "hUy1cHORegUzitHu"; // Replace with the authorization token for the Cropped Image API
    } else if (documentType === "binary") {
      url =
        "https://pzv3rtdoy6.execute-api.ap-south-1.amazonaws.com/default/ainxt_signature-background-remover?type=Binary";
    }

    var config = {
      method: "post",
      url: url,
      headers: {
        "x-api-key": apiKey,
        ...(authorizationToken && { authorizationToken }),
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        setCardData(response.data);
        setLoading(true);
      })
      .catch(function (error) {
        setLoading(true);
        alert("Something went wrong with the server");
      });
  };

  const handleDocumentTypeChange = (e) => {
    setDocumentType(e.target.value);
  };
  

  const renderTable = () => {
    if (documentType === "croppedImage" && cardData.status) {
      return (
        <table className="table">
          <tbody>
            <tr>
              <th>Status</th>
              <td>{cardData.status}</td>
            </tr>
            <tr>
              <th>Crop Status</th>
              <td>{cardData.cropped_status}</td>
            </tr>
            <tr>
              <th>Remark</th>
              <td>{cardData.remark}</td>
            </tr>
            <tr>
              <th>Sign Label</th>
              <td>{cardData.sign_label}</td>
            </tr>
          </tbody>
        </table>
      );
    } else if (cardData.encoded_string && cardData.status) {
      return (
        <table className="table">
          <tbody>
            <tr>
              <th>Status</th>
              <td>{cardData.status}</td>
            </tr>
          </tbody>
        </table>
      );
    } else {
      return null;
    }
  };

  return (
    <div>
      <div className="container containerBoreder" id="pan">
        <h2 className="pageTitle">Sign Background and Binary check</h2>
  
        <div className="col-4">
          <select value={documentType} onChange={handleDocumentTypeChange}>
            <option value="backgroundRemoval">Background Removal</option>
            {/* <option value="croppedImage">Cropped Image</option> */}
            <option value="binary">Binary</option>
          </select>
        </div>
        <br />
  
        <div className="row">
          <div className="col-4">
            <input type="file" onChange={onChange} />
            <span />
            {previewImg && (
              <img
                src={previewImg}
                alt="Preview"
                style={{
                  width: "100%",
                  marginTop: "10px",
                  border: "3px solid #555",
                }}
              />
            )}
          </div>
  
          <div className="col-8">
            <div className="row">
              <div className="col-4">
                {loading ? (
                  <button className="btn btn-primary" onClick={submit}>
                    Submit
                  </button>
                ) : (
                  <ReactBootStrap.Spinner animation="border" />
                )}
              </div>
              {previewImg && (
                <div style={{ marginTop: "40px" }}>
                  {documentType !== "croppedImage" && cardData.cropped_sign && (
                    <div
                      style={{
                        overflow: "hidden",
                        border: "3px solid #555",
                        maxWidth: "400px",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          height: "300px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <img
                          style={{
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                          }}
                          src={`data:image/png;base64,${cardData.cropped_sign}`}
                          alt="Cropped Sign"
                        />
                      </div>
                    </div>
                  )}
  
                  {cardData.encoded_string && (
                    <div>
                      <div
                        style={{
                          aspectRatio: `${cardData.encoded_string_width}/${cardData.encoded_string_height}`,
                        }}
                      >
                        <img
                          style={{
                            objectFit: "contain",
                            border: "3px solid #555",
                          }}
                          src={`data:image/png;base64,${cardData.encoded_string}`}
                          alt="Encoded String"
                        />
                      </div>
                      <div>
                        <a
                          href={`data:image/png;base64,${cardData.encoded_string}`}
                          download="encoded_string.png"
                          className="btn btn-primary mt-3"
                        >
                          Download Encoded String
                        </a>
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <br />
        <br />
        {renderTable()}
      </div>
    </div>
  );
  
}

export default SignCrop;
